import { hasDefinedValue } from '@sgme/fp';
import type { AddonPersistedTabContent, PersistedTabContent } from 'apiConnector/tabs/tabs.model';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { addonFormRequested } from 'state/addonForm/addonForm.action';
import type { EpicWithThunk } from 'state/state.common';

export function fillAddonTabContentInPostTradeScreenEpic(): EpicWithThunk {
  return (actions$, _state$, { frontLogger }) => {
    return actions$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ workspace }) => workspace === 'postTrade'),
      filter(({ tabType }) => tabType === 'addOn'),
      filter(hasDefinedValue('tabContent')),
      map(({ tabId, tabContent }) => addonFormRequestedFromAddonTabContent(tabId, tabContent)),
      catchError(err => {
        frontLogger.error('Error in fillAddonTabContentInPostTradeScreenEpic {@FrontError}', err);
        return EMPTY;
      }),
    );
  };
}

const addonFormRequestedFromAddonTabContent = (tabId: string, tabContent: PersistedTabContent) => {
  const addonTabContent = asAddonTabContent(tabContent);
  return addonFormRequested(tabId, addonTabContent.productId, addonTabContent.rfqId);
};

const asAddonTabContent = (tabContent: PersistedTabContent) => tabContent as AddonPersistedTabContent;
